import React from 'react';
import { useTranslation } from 'react-i18next';
import { AddonServiceLine, formatCurrency } from '../utils';
import { getCurrentLang } from '../i18n/i18n';

type Props = {
    lines?: AddonServiceLine[];
    additionalService: number;
};

// Renders the add-on portion of a reservation price summary: one row per booked
// add-on when itemized lines are available (compulsory add-ons — cleaning fee,
// tourist tax, … — and selected optional services each rendered by their real
// service name), otherwise a single summed fallback row.
// Shared by the venue and apartment summaries so the markup lives in one place.
const AddonServiceLines: React.FC<Props> = ({ lines, additionalService }) => {
    const { t } = useTranslation();

    if (lines && lines.length > 0) {
        return (
            <>
                {lines.map((line, index) => (
                    <div key={`${line.name}-${index}`} className={'flex justify-between text-sm'}>
                        <span>
                            {line.name}
                            {line.quantity ? ` · ${t('booking_details.quantity')} ${line.quantity}` : ''}
                        </span>
                        <span>{formatCurrency(line.amount, getCurrentLang())}</span>
                    </div>
                ))}
            </>
        );
    }

    return (
        <div className={'flex justify-between text-sm'}>
            <span>{t('booking_details.reservation_summary.additional_services')}</span>
            <span>{formatCurrency(additionalService, getCurrentLang())}</span>
        </div>
    );
};

export default AddonServiceLines;
